const { requestServices } = require('../../constant/request.services.constant');

const HEARING_ANALYSIS_LABEL = 'Análise de Audiência';

const buildGroupServiceAlert = (request) => {
    const groupIds = (request && request.groupFaciliterLinkServicesIds) || [];
    if (groupIds.length < 2) return null;

    const { petition, analysis, hearing, hearingInPerson } = requestServices.structure;

    const isHearingGroup = groupIds.includes(hearing.id) || groupIds.includes(hearingInPerson.id);
    if (isHearingGroup) {
        const modality = groupIds.includes(hearingInPerson.id) ? 'presencial' : 'virtual';
        return {
            title: request.faciliterServiceName,
            isHearingGroup: true,
            heading: 'Este serviço tem duas etapas vinculadas:',
            steps: [
                { label: HEARING_ANALYSIS_LABEL, body: 'deve ser realizada imediatamente após a vinculação' },
                { label: `Audiência ${modality}`, body: 'liberada automaticamente ao concluir a Análise de Audiência, para que você realize o ato' }
            ]
        };
    }

    const isAnalysisPetitionGroup = groupIds.includes(analysis.id) && groupIds.includes(petition.id);
    if (isAnalysisPetitionGroup) {
        return {
            title: request.faciliterServiceName,
            isHearingGroup: false,
            first: analysis.name,
            second: petition.name,
            message: `Após concluir a ${analysis.name}, o serviço de ${petition.name} será automaticamente encaminhado para você elaborar.`
        };
    }

    return null;
};

module.exports = { buildGroupServiceAlert };
